module.exports = "#version 300 es\nprecision highp float;\n\nin vec4 fs_Col;\nin vec4 fs_Pos;\nin vec4 fs_Nor;\n\nout vec4 out_Col;\n\nvoid main()\n{\n    vec3 ld = normalize(vec3(1.f));\n    float lamb = dot(ld, fs_Nor.xyz);\n    vec4 col = vec4(vec3(1.f, 1.f, 1.f) * lamb, 1.f);\n    float len = length(fs_Pos);\n    out_Col = col;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/ground-frag.glsl
// module id = 82
// module chunks = 0